import { render, staticRenderFns } from "./FormContributors.vue?vue&type=template&id=658b8026&scoped=true"
import script from "./FormContributors.vue?vue&type=script&lang=js"
export * from "./FormContributors.vue?vue&type=script&lang=js"
import style0 from "./FormContributors.vue?vue&type=style&index=0&id=658b8026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b8026",
  null
  
)

export default component.exports